import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=7d30c6b8&scoped=true"
import script from "./UiCard.vue?vue&type=script&lang=ts"
export * from "./UiCard.vue?vue&type=script&lang=ts"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=7d30c6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d30c6b8",
  null
  
)

export default component.exports